// extracted by mini-css-extract-plugin
export default {"total":"Representative_total__qly0X"};